// @flow
import {
  LOGIN_USER,
  LOGIN_USER_SUCCESS,
  LOGIN_USER_FAILED,
  LOGOUT_USER,
  REGISTER_USER,
  REGISTER_USER_SUCCESS,
  REGISTER_USER_FAILED,
  FORGET_PASSWORD,
  FORGET_PASSWORD_SUCCESS,
  FORGET_PASSWORD_FAILED,
  GET_ME,
  SET_USER,
  SET_PENDUDUK,
  SET_DESA,
  ACCESS_BLOCKED,
  HANDLE_ERROR,
  GET_ME_FAILED,
  SET_SUMMARY_DATA,
  SET_LOADING,
} from "./constants";

type AuthAction = { type: string, payload: {} | string };

export const loginUser = (username: string, password: string): AuthAction => ({
  type: LOGIN_USER,
  payload: { username, password },
});

export const loginUserSuccess = (user: string): AuthAction => ({
  type: LOGIN_USER_SUCCESS,
  payload: user,
});

export const setDesa = (desa) => ({
  type: SET_DESA,
  payload: desa,
});

export const loginUserFailed = (error: string): AuthAction => ({
  type: LOGIN_USER_FAILED,
  payload: error.response.data,
});

export const registerUser = (
  fullname: string,
  email: string,
  password: string
): AuthAction => ({
  type: REGISTER_USER,
  payload: { fullname, email, password },
});

export const registerUserSuccess = (user: {}): AuthAction => ({
  type: REGISTER_USER_SUCCESS,
  payload: user,
});

export const registerUserFailed = (error: string): AuthAction => ({
  type: REGISTER_USER_FAILED,
  payload: error,
});

export const logoutUser = (history: any): AuthAction => ({
  type: LOGOUT_USER,
  payload: { history },
});

export const forgetPassword = (username: string): AuthAction => ({
  type: FORGET_PASSWORD,
  payload: { username },
});

export const forgetPasswordSuccess = (
  passwordResetStatus: string
): AuthAction => ({
  type: FORGET_PASSWORD_SUCCESS,
  payload: passwordResetStatus,
});

export const forgetPasswordFailed = (error: string): AuthAction => ({
  type: FORGET_PASSWORD_FAILED,
  payload: error,
});

export const getMe = (history) => ({
  type: GET_ME,
  payload: { history },
});

export const handleErrorActions = (href) => ({
  type: HANDLE_ERROR,
  payload: href,
});

export const setUser = (user) => ({
  type: SET_USER,
  payload: user,
});

export const setPenduduk = (user) => ({
  type: SET_PENDUDUK,
  payload: user,
});

export const accessBlocked = () => ({
  type: ACCESS_BLOCKED,
});

export const getMeFailed = () => ({
  type: GET_ME_FAILED,
});

export const setSummaryData = (summaryData) => ({
  type: SET_SUMMARY_DATA,
  payload: summaryData,
});

export const setLoading = (loading) => ({
  type: SET_LOADING,
  payload: loading,
});
